/**
 * Router Authentication Configuration
 */

import { isRouteAccessible } from '../utils/menuVisibility';

let currentEvents;

function isLoggedIn() {
  return !!localStorage.getItem('userToken');
}

function redirectBlockedRoute(next) {
  if (isLoggedIn()) {
    next({ path: '/' });
  } else {
    next({ path: '/login' });
  }
}

function getStatusPermission(to) {
  const credentials = JSON.parse(localStorage.getItem('userCredentials')) || {};
  const authRequirements = to.meta.credentials;
  if (!Array.isArray(authRequirements) || authRequirements.length === 0) {
    return true;
  }
  return authRequirements.some((request) => credentials[request]);
}

export function applyRules(router) {
  router.beforeEach((to, from, next) => {
    if (!isRouteAccessible(to.name)) {
      redirectBlockedRoute(next);
      return;
    }

    if (!to.meta.requiresAuth) {
      next();
      return;
    }

    if (!isLoggedIn()) {
      currentEvents.$emit('closeSession', to.fullPath);
      return;
    }

    const allowedToContinue = getStatusPermission(to);
    if (!allowedToContinue && from.name === 'login') {
      next({ path: '/' });
    } else if (allowedToContinue) {
      next();
    } else {
      currentEvents.$emit('closeSession');
    }
  });
}

export function setEvents(events) {
  currentEvents = events;
}

export default {
  applyRules,
  setEvents,
};
